
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/car-maintenance/page/[page]",
      function () {
        return require("private-next-pages/guides/car-maintenance/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/car-maintenance/page/[page]"])
      });
    }
  